var _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTsLogoRgbHor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 403 81.6",
    style: {
      enableBackground: "new 0 0 403 81.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C25700;}\n\t.st1{fill:#4C79AF;}\n\t.st2{fill:#386097;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#386097;}\n")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C25700"
    },
    d: "M79.3,8.4L79.3,8.4c0-4.6-3.7-8.4-8.4-8.4c0,0,0,0,0,0H8.4C3.8,0,0,3.7,0,8.3c0,4.6,3.7,8.4,8.3,8.4 c0,0,0,0,0,0l54.2,0l0,54.2c0,4.6,3.8,8.4,8.4,8.4c4.6,0,8.4-3.7,8.4-8.4L79.3,8.4L79.3,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C79AF"
    },
    d: "M54.8,32.8c0-4.6-3.7-8.4-8.4-8.4c0,0,0,0,0,0H8.4c-4.6,0-8.3,3.7-8.4,8.3s3.7,8.3,8.3,8.4c0,0,0,0,0,0h29.7 l0,29.8c0,4.6,3.7,8.4,8.3,8.4c4.6,0,8.4-3.7,8.4-8.3c0,0,0,0,0,0L54.8,32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M30.4,57c0-4.5-3.6-8.1-8.1-8.1H8.1C3.7,48.8,0,52.5,0,57c0,4.5,3.6,8.1,8.1,8.1l0,0l6,0l0,6 c0,4.5,3.6,8.1,8.1,8.1c4.5,0,8.1-3.6,8.1-8.1c0,0,0,0,0,0L30.4,57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M128.9,15.1v3.5h-10.5v27.9h-4.2V18.6h-10.5v-3.5H128.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M134.9,23.2c5.7,0,8.5,2,8.5,6.1v13.1c0,0.9,0.4,1.3,1.2,1.3c0.4,0,0.8-0.1,1.1-0.2v2.9 c-0.8,0.4-1.8,0.6-2.7,0.6c-2.1,0-3.2-1.2-3.2-3.5c-2,2.3-4.9,3.6-8,3.5c-2,0.1-3.9-0.5-5.5-1.7c-1.4-1.2-2.1-2.9-2-4.7 c-0.1-1.8,0.6-3.6,2-4.8c1.3-1.2,4.4-2.1,9.2-2.7c1.2-0.1,2.3-0.4,3.3-0.9c0.6-0.4,0.9-1.1,0.9-1.9c0-2.5-1.7-3.7-5.1-3.7 c-1.5-0.1-2.9,0.3-4.2,1c-1,0.8-1.5,2-1.5,3.3h-3.7C125.5,25.8,128.7,23.2,134.9,23.2z M128.3,40.4c0,1,0.4,1.9,1.1,2.5 c1,0.6,2.1,1,3.3,0.9c1.8,0.1,3.5-0.5,5-1.5c1.2-0.8,1.9-2.1,2-3.6v-3.9c-0.8,0.5-1.7,0.8-2.6,0.9l-3.8,0.6 c-1.3,0.1-2.6,0.6-3.7,1.3C128.7,38.3,128.2,39.3,128.3,40.4L128.3,40.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M152.9,15.1v31.4h-3.7V15.1L152.9,15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M168,23.2c2.9-0.1,5.8,1.2,7.6,3.5c1.9,2.6,2.9,5.8,2.7,9.1v0.4h-17v0.3c-0.1,1.9,0.6,3.8,1.9,5.3 c1.4,1.4,3.3,2.1,5.2,2c3.3,0,5.2-1.5,5.9-4.4h3.7c-0.3,2.3-1.5,4.3-3.3,5.8c-1.9,1.4-4.1,2-6.4,2c-3.6,0-6.3-1.2-8.1-3.5 c-1.9-2.4-2.9-5.5-2.8-8.5c-0.1-3.1,1-6.1,3-8.4C162.3,24.4,165.1,23.2,168,23.2z M174.3,33c-0.1-1.7-0.8-3.4-2-4.6 c-1.2-1.2-2.9-1.9-4.6-1.8c-1.6,0-3.2,0.6-4.4,1.7c-1.2,1.3-2,2.9-2.1,4.7H174.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M192.9,23.2c5.2,0,7.8,2.7,7.8,8.1v15.1H197V31c0-1.2-0.4-2.3-1.2-3.2c-0.9-0.9-2.2-1.4-3.5-1.3 c-1.9-0.1-3.7,0.6-5,1.9c-1.2,1.4-1.8,3.2-1.7,5.1v13h-3.7V23.8h3.5v3.6h0.1C187,24.7,189.9,23.1,192.9,23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M210.5,16.9v6.8h4.5v3.3h-4.5v14.3c0,0.5,0.1,1,0.4,1.5c0.3,0.3,0.9,0.4,2,0.4h2.2v3.3h-3.1c-1.9,0-3.3-0.3-4-1 c-0.8-0.6-1.1-1.9-1.1-3.8V27.1h-3.9v-3.3h3.9v-6.8H210.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M242,14.4c3.5,0,6.4,0.9,8.4,2.6c2.1,1.8,3.3,4.5,3.1,7.3h-4c-0.5-4.3-3.1-6.4-7.8-6.4 c-1.8-0.1-3.7,0.4-5.2,1.4c-1.2,0.9-1.9,2.4-1.8,4c0,1.1,0.5,2.2,1.4,2.9c0.9,0.8,3.8,1.7,8.7,2.7c2.7,0.4,5.3,1.5,7.5,3.1 c1.7,1.5,2.6,3.7,2.5,5.9c0.1,2.8-1.3,5.4-3.6,6.9c-2.6,1.7-5.6,2.6-8.7,2.5c-4,0-7.1-1-9.5-3c-2.4-2-3.7-5-3.5-8.1h4 c-0.1,2.2,0.9,4.3,2.6,5.6c1.9,1.4,4.2,2.1,6.6,2c2.1,0.1,4.1-0.4,5.9-1.5c1.4-1,2.2-2.6,2.1-4.2c0-1.5-0.7-2.9-2-3.6 c-2.1-1.2-4.4-1.9-6.8-2.3c-4.6-0.9-7.6-2-9.1-3.3c-1.5-1.3-2.3-3.3-2.2-5.2c-0.1-2.6,1.1-5.1,3.1-6.7 C236.2,15.1,239.1,14.2,242,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M268.1,23.2c3-0.1,6,1,8.1,3.3c4,5.1,4,12.2,0,17.2c-2.1,2.3-5,3.5-8.1,3.3c-3,0.1-5.9-1-8-3.2 c-2.1-2.4-3.2-5.5-3-8.6c-0.2-3.2,0.9-6.3,3-8.7C262.1,24.3,265.1,23.1,268.1,23.2z M261,35.2c-0.1,2.2,0.6,4.4,2,6.2 c2.4,2.8,6.6,3.2,9.4,0.8c0.3-0.2,0.6-0.5,0.8-0.8c1.4-1.8,2.1-4,2-6.2c0.1-2.2-0.6-4.5-2-6.2c-1.2-1.6-3.2-2.5-5.1-2.4 c-2,0-3.8,0.9-5,2.4C261.6,30.7,260.9,32.9,261,35.2L261,35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M286.4,15.1v31.4h-3.7V15.1L286.4,15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M295.7,23.8v15.5c0,1.2,0.4,2.4,1.2,3.2c0.9,0.9,2.1,1.3,3.4,1.3c1.9,0.1,3.7-0.6,5-1.9 c1.2-1.4,1.8-3.2,1.7-5.1v-13h3.7v22.7h-3.5v-3.6h-0.1c-1.4,2.7-4.3,4.3-7.4,4.1c-5.2,0-7.8-2.7-7.8-8.1V23.8H295.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M320.5,16.9v6.8h4.5v3.3h-4.5v14.3c0,0.5,0.1,1,0.4,1.5c0.3,0.3,0.9,0.4,2,0.4h2.2v3.3H322c-1.9,0-3.3-0.3-4-1 c-0.8-0.6-1.1-1.9-1.1-3.8V27.1h-3.9v-3.3h3.9v-6.8H320.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M332.1,15.1v4.6h-3.7v-4.6H332.1z M332.1,23.8v22.7h-3.7V23.8L332.1,23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M346.6,23.2c3-0.1,6,1,8.1,3.3c4,5.1,4,12.2,0,17.2c-2.1,2.3-5,3.5-8.1,3.3c-3,0.1-5.9-1-8-3.2 c-2.1-2.4-3.2-5.5-3-8.6c-0.2-3.2,0.9-6.3,3-8.7C340.6,24.3,343.5,23.1,346.6,23.2z M339.5,35.2c-0.1,2.2,0.6,4.4,2,6.2 c2.4,2.8,6.6,3.2,9.4,0.8c0.3-0.2,0.6-0.5,0.8-0.8c1.4-1.8,2.1-4,2-6.2c0.1-2.2-0.6-4.5-2-6.2c-1.2-1.6-3.2-2.5-5.1-2.4 c-2,0-3.8,0.9-5,2.4C340.1,30.7,339.4,32.9,339.5,35.2L339.5,35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M372.8,23.2c5.2,0,7.8,2.7,7.8,8.1v15.1h-3.7V31c0.1-2.3-1.7-4.3-4-4.5c-0.2,0-0.4,0-0.6,0 c-1.9-0.1-3.7,0.6-5,1.9c-1.2,1.4-1.8,3.2-1.7,5.1v13h-3.7V23.8h3.5v3.6h0.1C366.9,24.7,369.8,23.1,372.8,23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M392.7,23.2c3.1,0,5.4,0.6,6.8,1.8c1.6,1.3,2.4,3.3,2.4,5.3h-3.7v0c-0.1-1.1-0.7-2.2-1.6-2.8 c-1.1-0.7-2.4-1-3.7-1c-1.2-0.1-2.4,0.2-3.5,0.7c-1.2,0.6-1.6,2.1-1,3.3c0.2,0.4,0.5,0.7,0.9,0.9c1.1,0.6,2.2,1.1,3.5,1.3l3.5,0.8 c1.8,0.3,3.5,1.1,5,2.2c1.2,1,1.8,2.5,1.7,4.1c0.1,2.1-0.9,4.1-2.6,5.3c-2.1,1.4-4.6,2-7.1,1.9c-2.4,0.1-4.9-0.5-6.9-1.9 c-1.8-1.4-2.8-3.5-2.7-5.8h3.7c0,1.3,0.6,2.5,1.7,3.3c1.3,0.8,2.9,1.2,4.4,1.1c3.7,0,5.5-1.1,5.5-3.4c0-1-0.5-1.9-1.3-2.4 c-1.8-0.9-3.7-1.5-5.7-1.8c-2.2-0.3-4.2-1.1-6-2.3c-1.2-1-1.9-2.6-1.8-4.1c0-1.8,0.8-3.6,2.3-4.7C388.3,23.7,390.5,23.1,392.7,23.2z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#386097"
    },
    d: "M245.3,65.2h0.4c0.4,0,0.7,0,0.7-0.4c0-0.3-0.3-0.4-0.6-0.4h-0.5L245.3,65.2L245.3,65.2z M244.9,64.1h1 c0.6,0,0.9,0.2,0.9,0.7c0,0.4-0.3,0.7-0.6,0.7c0,0,0,0-0.1,0l0.7,1.1h-0.4l-0.7-1.1h-0.4v1.1h-0.4L244.9,64.1L244.9,64.1z  M245.8,67.2c1,0,1.9-0.8,2-1.8c0-1-0.8-1.9-1.8-2c-1,0-1.9,0.8-2,1.8c0,0,0,0,0,0.1C243.9,66.4,244.7,67.2,245.8,67.2 C245.7,67.2,245.8,67.2,245.8,67.2z M245.8,63.2c1.2,0,2.2,1,2.2,2.2c0,1.2-1,2.2-2.2,2.2c-1.2,0-2.2-1-2.2-2.2c0,0,0,0,0,0 C243.6,64.1,244.5,63.2,245.8,63.2C245.8,63.2,245.8,63.2,245.8,63.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M107.7,64.5l4.2,11.2l4.2-11.2h2.4v13.4h-1.7V66.7h0l-4.2,11.1h-1.5L107,66.7h0v11.1h-1.7V64.5H107.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M125,67.9c2.4,0,3.6,0.9,3.6,2.6v5.6c0,0.4,0.2,0.5,0.5,0.5c0.2,0,0.3,0,0.5-0.1v1.2c-0.4,0.2-0.7,0.3-1.1,0.3 c-0.9,0-1.3-0.5-1.3-1.5c-0.8,1-2.1,1.6-3.4,1.5c-0.8,0-1.7-0.2-2.4-0.7c-0.6-0.5-0.9-1.2-0.9-2c0-0.8,0.3-1.5,0.8-2.1 c0.6-0.5,1.9-0.9,3.9-1.2c0.5,0,1-0.2,1.4-0.4c0.2-0.2,0.4-0.5,0.4-0.8c0-1.1-0.7-1.6-2.2-1.6c-0.6,0-1.2,0.1-1.8,0.4 c-0.4,0.3-0.7,0.9-0.6,1.4h-1.6C121,69,122.3,67.9,125,67.9z M122.2,75.2c0,0.4,0.2,0.8,0.5,1c0.4,0.3,0.9,0.4,1.4,0.4 c0.8,0,1.5-0.2,2.1-0.6c0.5-0.3,0.8-0.9,0.8-1.5v-1.7c-0.3,0.2-0.7,0.4-1.1,0.4l-1.6,0.2c-0.6,0-1.1,0.2-1.6,0.6 C122.3,74.3,122.1,74.8,122.2,75.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M135.7,67.9c2.2,0,3.3,1.2,3.3,3.5v6.5h-1.6v-6.6c0-0.5-0.2-1-0.5-1.3c-0.4-0.4-0.9-0.6-1.5-0.5 c-0.8,0-1.6,0.3-2.1,0.8c-0.5,0.6-0.8,1.4-0.7,2.2v5.5H131v-9.7h1.5v1.5h0C133.2,68.6,134.4,67.9,135.7,67.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M146.3,67.9c1.2-0.1,2.4,0.5,3.3,1.4c0.8,1,1.3,2.4,1.2,3.7c0.1,1.3-0.4,2.6-1.2,3.7c-0.8,0.9-2,1.4-3.2,1.4 c-0.6,0-1.2-0.1-1.8-0.4c-0.6-0.2-1-0.6-1.4-1.2h0v5h-1.6V68.2h1.6v1.3h0C143.8,68.4,145,67.8,146.3,67.9z M143.1,73 c-0.1,1,0.2,1.9,0.8,2.7c0.6,0.7,1.4,1,2.3,1c0.8,0,1.6-0.3,2.1-1c0.6-0.8,0.8-1.8,0.8-2.8c0-0.9-0.2-1.8-0.8-2.6 c-0.5-0.7-1.4-1-2.2-1c-0.8,0-1.6,0.3-2.1,1C143.3,71.1,143,72,143.1,73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M156.7,67.9c1.3-0.1,2.6,0.4,3.4,1.4c1.7,2.2,1.7,5.2,0,7.3c-0.9,1-2.1,1.5-3.4,1.4c-1.3,0.1-2.5-0.4-3.4-1.4 c-0.9-1-1.4-2.3-1.3-3.7c-0.1-1.4,0.4-2.7,1.3-3.7C154.1,68.4,155.4,67.9,156.7,67.9z M153.7,73c0,1,0.3,1.9,0.8,2.6 c1,1.2,2.8,1.4,4,0.3c0.1-0.1,0.2-0.2,0.3-0.3c0.6-0.8,0.9-1.7,0.9-2.7c0-1-0.3-1.9-0.8-2.7c-0.5-0.7-1.3-1-2.2-1 c-0.8,0-1.6,0.4-2.1,1C153.9,71.1,153.6,72.1,153.7,73L153.7,73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M163.7,68.2l2.2,7.9h0l2-7.9h1.7l2,7.9h0l2.2-7.9h1.6l-3.1,9.7l0,0h-1.7l-2-7.7h0l-2,7.7H165l-3.1-9.7H163.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M180.5,67.9c1.3-0.1,2.5,0.5,3.2,1.5c0.8,1.1,1.2,2.5,1.2,3.9v0.2h-7.3v0.1c0,0.8,0.2,1.6,0.8,2.2 c0.6,0.6,1.4,0.9,2.2,0.8c1.2,0.1,2.3-0.7,2.5-1.9h1.6c-0.1,1-0.6,1.8-1.4,2.5c-0.8,0.6-1.8,0.9-2.7,0.8c-1.3,0.1-2.6-0.5-3.5-1.5 c-0.8-1-1.2-2.3-1.2-3.6c0-1.3,0.4-2.6,1.3-3.6C178.1,68.4,179.2,67.9,180.5,67.9z M183.2,72.1c0-0.7-0.3-1.4-0.9-2 c-0.5-0.5-1.2-0.8-2-0.8c-0.7,0-1.4,0.3-1.9,0.7c-0.5,0.5-0.8,1.2-0.9,2L183.2,72.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M191.6,67.9v1.7c-1-0.1-1.9,0.3-2.7,0.9c-0.6,0.8-0.9,1.9-0.9,3v4.3h-1.6v-9.7h1.5v2h0c0.5-1.4,1.9-2.3,3.3-2.3 L191.6,67.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M199.5,64.1c1.4-0.1,2.8,0.3,3.9,1.1c1,0.8,1.7,2,1.8,3.3h-1.8c-0.1-0.9-0.6-1.7-1.3-2.2 c-0.8-0.5-1.7-0.8-2.7-0.8c-1.3,0-2.5,0.5-3.3,1.5c-0.9,1.2-1.3,2.7-1.3,4.1c0,1.4,0.4,2.7,1.3,3.8c0.8,1,2,1.6,3.3,1.5 c1.1,0,2.2-0.4,3.1-1.1c0.8-0.8,1.3-1.9,1.2-3v-0.2h-4.3v-1.5h5.9v7h-1.1l-0.5-1.7c-0.5,0.6-1.1,1.1-1.9,1.5 c-0.8,0.3-1.6,0.5-2.4,0.5c-1.7,0-3.4-0.7-4.6-1.9c-1.2-1.3-1.9-3-1.8-4.8c-0.1-1.9,0.5-3.7,1.7-5.2C196,64.8,197.7,64.1,199.5,64.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M213,67.9v1.7c-1-0.1-1.9,0.3-2.7,0.9c-0.6,0.8-0.9,1.9-0.9,3v4.3h-1.6v-9.7h1.5v2h0c0.5-1.4,1.9-2.3,3.3-2.3 L213,67.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M218,67.9c1.3-0.1,2.6,0.4,3.4,1.4c1.7,2.2,1.7,5.2,0,7.3c-0.9,1-2.1,1.5-3.4,1.4c-1.3,0.1-2.5-0.4-3.4-1.4 c-0.9-1-1.4-2.3-1.3-3.7c-0.1-1.4,0.4-2.7,1.3-3.7C215.4,68.4,216.7,67.9,218,67.9z M214.9,73c0,1,0.3,1.9,0.8,2.6 c1,1.2,2.8,1.4,4,0.3c0.1-0.1,0.2-0.2,0.3-0.3c0.6-0.8,0.9-1.7,0.9-2.7c0-1-0.3-1.9-0.8-2.7c-0.5-0.7-1.3-1-2.2-1 c-0.8,0-1.6,0.4-2.1,1C215.2,71.1,214.9,72.1,214.9,73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M225.9,68.2v6.6c0,0.5,0.2,1,0.5,1.4c0.4,0.4,0.9,0.6,1.4,0.5c0.8,0.1,1.6-0.2,2.1-0.8c0.5-0.6,0.8-1.4,0.7-2.2 v-5.5h1.6v9.7h-1.5v-1.5h0c-0.6,1.1-1.8,1.8-3.2,1.8c-2.2,0-3.3-1.1-3.3-3.4v-6.5H225.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386097"
    },
    d: "M239.2,67.9c1.2-0.1,2.4,0.5,3.3,1.4c0.8,1,1.3,2.4,1.2,3.7c0.1,1.3-0.4,2.6-1.2,3.7c-0.8,0.9-2,1.4-3.2,1.4 c-0.6,0-1.2-0.1-1.8-0.4c-0.6-0.2-1-0.6-1.4-1.2h0v5h-1.6V68.2h1.6v1.3h0C236.7,68.4,237.9,67.8,239.2,67.9z M236,73 c-0.1,1,0.2,1.9,0.8,2.7c0.6,0.7,1.4,1,2.3,1c0.8,0,1.6-0.3,2.1-1c0.6-0.8,0.8-1.8,0.8-2.8c0-0.9-0.2-1.8-0.8-2.6 c-0.5-0.7-1.4-1-2.2-1c-0.8,0-1.6,0.3-2.1,1C236.2,71.1,235.9,72,236,73L236,73z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTsLogoRgbHor);
export default __webpack_public_path__ + "static/media/TS_Logo_RGB_HOR.57218b90652793a228594f00d5701989.svg";
export { ForwardRef as ReactComponent };